// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_cs-0";
export var actionModalContentContainer = "_cs-1";
export var createTagButton = "_cs-2";
export var footerContainer = "_cs-7";
export var fullWidthDivider = "_cs-3";
export var hasCreateTagButton = "_cs-4";
export var noCreateTagButton = "_cs-5";
export var tagsContainer = "_cs-6";
export var tagsModalContentContainer = "_cs-8";